export const GET_SKILLS = 'GET_SKILLS';
export const GET_SKILL = 'GET_SKILL';
